import { render, staticRenderFns } from "./PayoffStructure.vue?vue&type=template&id=85af054c&scoped=true"
import script from "./PayoffStructure.vue?vue&type=script&lang=js"
export * from "./PayoffStructure.vue?vue&type=script&lang=js"
import style0 from "./PayoffStructure.vue?vue&type=style&index=0&id=85af054c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85af054c",
  null
  
)

export default component.exports